// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1LGP0","title":"styles_title__20Xv5","icon":"styles_icon__2uypI","badgeText":"styles_badgeText__2laXA"};